//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/**
 * Rotate an array to the left.
 *
 * e.g. ROTL 1 [1,2,3] ==> [2,3,1]
 * @param arr Input Array
 * @param count Number of rotations. Default 1.
 */
export function rotateArrayLeft<T>(arr: readonly T[], count = 1): readonly T[] {
  count %= arr.length;
  return arr.slice(count).concat(arr.slice(0, count));
}
/**
 * Rotate an array to the right.
 *
 * e.g. ROTR 1 [1,2,3] ==> [3,1,2]
 * @param arr Input Array
 * @param count Number of rotations. Default 1.
 */
export function rotateArrayRight<T>(arr: readonly T[], count = 1): readonly T[] {
  return rotateArrayLeft(arr, -count);
}
